import React from "react";
import { FeeTable } from "../types";

// One level more nested than ObjectListEditor can express (each table has a
// title plus its own array of {label, amount} rows), so it gets its own
// small component rather than forcing it through the generic one.
export default function FeeTablesEditor(props: {
  values: FeeTable[];
  onChange: (values: FeeTable[]) => void;
}) {
  const { values, onChange } = props;

  function updateTable(index: number, patch: Partial<FeeTable>) {
    const next = [...values];
    next[index] = { ...next[index], ...patch };
    onChange(next);
  }

  function removeTable(index: number) {
    onChange(values.filter((_, i) => i !== index));
  }

  function addRow(tableIndex: number) {
    const table = values[tableIndex];
    updateTable(tableIndex, { rows: [...table.rows, { label: "", amount: "" }] });
  }

  function updateRow(tableIndex: number, rowIndex: number, patch: Partial<{ label: string; amount: string }>) {
    const table = values[tableIndex];
    const rows = [...table.rows];
    rows[rowIndex] = { ...rows[rowIndex], ...patch };
    updateTable(tableIndex, { rows });
  }

  function removeRow(tableIndex: number, rowIndex: number) {
    const table = values[tableIndex];
    updateTable(tableIndex, { rows: table.rows.filter((_, i) => i !== rowIndex) });
  }

  return (
    <div className="mb-4">
      <span className="block text-sm text-secondary-dark mb-1.5">费用表（投资选项页）</span>
      <div className="flex flex-col gap-4">
        {values.map((table, tableIndex) => (
          <div key={tableIndex} className="border border-fourth-light rounded-lg p-3 bg-c-gray/40">
            <div className="flex items-center gap-2 mb-3">
              <input
                type="text"
                value={table.title}
                placeholder="表格标题，如「政府尽职调查费」"
                onChange={(e) => updateTable(tableIndex, { title: e.target.value })}
                className="flex-1 border border-fourth-light rounded-md px-2 py-1.5 text-sm font-medium outline-none focus:border-gold transition-colors bg-white"
              />
              <button type="button" onClick={() => removeTable(tableIndex)} className="text-red-400 hover:text-red-600 text-xs">
                删除表格
              </button>
            </div>
            <div className="flex flex-col gap-2">
              {table.rows.map((row, rowIndex) => (
                <div key={rowIndex} className="flex items-center gap-2">
                  <input
                    type="text"
                    value={row.label}
                    placeholder="申请人 / 项目"
                    onChange={(e) => updateRow(tableIndex, rowIndex, { label: e.target.value })}
                    className="flex-1 border border-fourth-light rounded-md px-2 py-1.5 text-sm outline-none focus:border-gold transition-colors bg-white"
                  />
                  <input
                    type="text"
                    value={row.amount}
                    placeholder="金额"
                    onChange={(e) => updateRow(tableIndex, rowIndex, { amount: e.target.value })}
                    className="w-32 border border-fourth-light rounded-md px-2 py-1.5 text-sm outline-none focus:border-gold transition-colors bg-white"
                  />
                  <button type="button" onClick={() => removeRow(tableIndex, rowIndex)} className="text-red-400 hover:text-red-600 text-xs px-1">
                    ✕
                  </button>
                </div>
              ))}
            </div>
            <button
              type="button"
              onClick={() => addRow(tableIndex)}
              className="mt-2 text-xs text-gold hover:text-secondary-dark transition-colors"
            >
              + 添加一行
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={() => onChange([...values, { title: "", rows: [] }])}
        className="mt-3 text-xs text-gold hover:text-secondary-dark transition-colors"
      >
        + 添加费用表
      </button>
    </div>
  );
}
